import { Storage } from "@capacitor/storage"
import { call, put } from "typed-redux-saga"
import { appActions } from ".."

export function* checkIntroCarouselSaga() {
  yield* call(Storage.set, { key: "isIntroCarouselChecked", value: "true" })
  yield* put(appActions.checkIntroCarousel.success())
}
